export default __webpack_public_path__ + "static/media/veganpals.7a201609.png";